import { useWindowResize } from '@lux/wardrobe-lib'
import './MainContent.scss'

const MainContent = (props) => {
    const { headerHeight, classes } = props
    const componentClass = 'smart-modals-main-content'
    const isMobile = useWindowResize()

    return (
        <div
            className={`${componentClass} wrapper ${classes || ''}`}
            style={
                isMobile && headerHeight
                    ? {
                          height:
                              isMobile && headerHeight
                                  ? `calc(100% - 75px - ${headerHeight || 0}px)`
                                  : '93%',
                      }
                    : {}
            }>
            <div className={`${componentClass}__body`}>{props.children}</div>
            {!props.hideFooter && (
                <div className={`${componentClass}__footer wrapper`}>{props.footer}</div>
            )}
        </div>
    )
}

export default MainContent
